import {
  CardBySlugSuccessSchema,
  isNotEmpty,
  type CardAttachmentId,
  type CardBySlugSuccess,
  type CardGalleryFile,
  type CardSlug,
} from '@terros/common'
import { useQuery } from '@tanstack/react-query'
import { getApiUrl, useBackend } from '@front/model'

export function useCardGallery(
  gallerySlug: CardSlug | undefined,
  attachmentIds: CardAttachmentId[]
): CardGalleryFile[] {
  const data = usePublicCard(gallerySlug)
  return data?.gallery.filter(({ attachmentId }) => attachmentIds.includes(attachmentId)) ?? []
}

export function usePublicCard(slug: CardSlug | undefined): CardBySlugSuccess | undefined {
  const backend = useBackend()
  const stage = backend.getStage()
  const { data } = useQuery({
    queryKey: ['public-card', stage, slug],
    queryFn: async () => {
      const response = await fetch(`${getApiUrl(stage)}/card/${encodeURIComponent(slug ?? '')}`)
      if (!response.ok) throw new Error('Unable to load card')
      return CardBySlugSuccessSchema.parse(await response.json())
    },
    enabled: isNotEmpty(slug),
    staleTime: 10 * 60 * 1000,
    retry: false,
  })

  return data
}
